function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "13",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Nearest-flight",
  transform: "translate(-1058 -432)",
  fill: "#95A0B3"
}, /*#__PURE__*/React.createElement("g", {
  id: "desktop",
  transform: "translate(216 200)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(360 220)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-Common-/-16-/-SeatEconomy",
  transform: "translate(478 10)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.41 13.79H8.683a.842.842 0 01-.817-.638L5.66 4.322a.842.842 0 00-1.635.408l2.208 8.831c.226.9.919 1.577 1.78 1.814L7.355 18h4.211l.632-2.526h.21a.842.842 0 100-1.685m4.501 3.103l-1.684-5.053a.842.842 0 00-.8-.576h-2.71L10.612 6.85a.841.841 0 00-.817-.638H8.113a.842.842 0 00-.817 1.045l1.249 4.995c.069.396.414.696.83.696h4.445l1.492 4.477a.843.843 0 001.598-.532M7.058 3.684a1.684 1.684 0 113.369 0 1.684 1.684 0 01-3.369 0",
  id: "SeatEconomy"
}))))))));